import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro1/Intro.jsx';
import Content from '../../components/user/sub4_3/Content.jsx';
import Footer from '../../components/user/footer/Footer.jsx';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub3_2() {
  const introData = {
    mainTitle: ' 인터뷰',
    subTitle: '크림봇을 사용하신 고객분들의 이야기를 확인해보세요',
    menuItems: [
      { title: '인터뷰 ', link: '/sub4_3', active:true  }
    ],
  };

  return (
    <>
      <Header />
      <SubIntro
        mainTitle={introData.mainTitle}
        subTitle={introData.subTitle}
        menuItems={introData.menuItems}
      />
      <Content />
      <Footer />
    </>
  );
}
